module.exports = __webpack_public_path__ + "assets/1be2efe54f8120a1df1d24d27df7a14c.png";